var _rect, _rect2, _rect3, _g, _rect4, _rect5, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard3Mob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 200,
    viewBox: "0 0 236 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 64.8313,
    width: 110.653,
    height: 70.3378,
    rx: 5.1714,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.93,
    y: 75.4751,
    width: 71.3453,
    height: 8.91817,
    rx: 4.45908,
    fill: "#A3BBD1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.22,
    y: 95.7112,
    width: 92.64,
    height: 9.43556,
    rx: 4.71778,
    fill: "#A3BBD1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_699)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.162,
    y: 64.8313,
    width: 70.3378,
    height: 70.3378,
    rx: 5.14667,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.412,
    y: 122.629,
    width: 93.0299,
    height: 3.72766,
    rx: 1.86383,
    transform: "rotate(-45 137.412 122.629)",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.06,
    y: 108.208,
    width: 12.9038,
    height: 14.0363,
    rx: 2.57333,
    transform: "rotate(-45 162.06 108.208)",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.217,
    y: 117.883,
    width: 50.8469,
    height: 14.0363,
    rx: 2.57333,
    transform: "rotate(-45 117.217 117.883)",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.202,
    y: 73.8972,
    width: 43.7414,
    height: 14.0363,
    rx: 2.57333,
    transform: "rotate(-45 161.202 73.8972)",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.909,
    y: 119.359,
    width: 12.9038,
    height: 14.0363,
    rx: 2.57333,
    transform: "rotate(-45 150.909 119.359)",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.358,
    y: 91.9106,
    width: 12.9038,
    height: 48.5688,
    rx: 2.57333,
    transform: "rotate(-45 178.358 91.9106)",
    fill: "#A3BBD1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.069,
    y: 120.217,
    width: 12.9038,
    height: 36.9048,
    rx: 2.57333,
    transform: "rotate(-45 174.069 120.217)",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.702 94.4281C174.43 93.7002 175.61 93.7002 176.338 94.4281L215.334 133.425C216.062 134.153 216.062 135.333 215.334 136.061V136.061C214.606 136.789 213.426 136.789 212.698 136.061L173.702 97.0639C172.974 96.336 172.974 95.1559 173.702 94.4281V94.4281Z",
    fill: "#C4D2E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.188 58.9156C138.916 58.1877 140.096 58.1877 140.824 58.9156L182.226 100.319C182.954 101.047 182.954 102.227 182.226 102.955V102.955C181.498 103.683 180.318 103.683 179.59 102.955L138.188 61.5514C137.46 60.8236 137.46 59.6435 138.188 58.9156V58.9156Z",
    fill: "#C4D2E0"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5264,
    y: 116.499,
    width: 50.8335,
    height: 8.91817,
    rx: 4.45908,
    fill: "#A3BBD1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91.8378,
    y: 116.298,
    width: 30.0222,
    height: 9.43556,
    rx: 4.71778,
    fill: "#A3BBD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2111 73.9148C33.8701 73.9148 31.752 75.7096 31.752 78.4854C31.752 80.2578 33.1176 82.3425 35.8432 84.7448C36.055 84.9287 36.3728 84.9287 36.5846 84.7448C39.3046 82.3425 40.6702 80.2578 40.6702 78.4854C40.6702 75.7096 38.5521 73.9148 36.2111 73.9148ZM36.2111 79.4886C35.598 79.4886 35.0963 78.987 35.0963 78.3739C35.0963 77.7608 35.598 77.2591 36.2111 77.2591C36.8242 77.2591 37.3259 77.7608 37.3259 78.3739C37.3259 78.987 36.8242 79.4886 36.2111 79.4886Z",
    fill: "#003A70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.462 95.3176C200.121 95.3176 198.003 97.1124 198.003 99.8882C198.003 101.661 199.368 103.745 202.094 106.148C202.306 106.332 202.623 106.332 202.835 106.148C205.555 103.745 206.921 101.661 206.921 99.8882C206.921 97.1124 204.803 95.3176 202.462 95.3176ZM202.462 100.891C201.849 100.891 201.347 100.39 201.347 99.7767C201.347 99.1636 201.849 98.6619 202.462 98.6619C203.075 98.6619 203.577 99.1636 203.577 99.7767C203.577 100.39 203.075 100.891 202.462 100.891Z",
    fill: "#003A70"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_699"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.046,
    y: 64.7732,
    width: 70.4535,
    height: 70.4535,
    rx: 5.14667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3Mob);
export default __webpack_public_path__ + "static/media/card3_mob.295860323fab713814eb0ea3c8a79205.svg";
export { ForwardRef as ReactComponent };